
import request from '@/utils/request'
import type { LoginParams, LoginResult, UserInfo, SysUserInfo, RegisterForm } from '@/types/user'
import type { ApiResponse } from '@/types/response'

// 登录
export const login = (data: LoginParams) => {
  return request.post('/auth/login', data) as Promise<ApiResponse<LoginResult>>
}

// 注册
export const register = (data: RegisterForm) => {
  return request.post('/auth/register', data) as Promise<ApiResponse<any>>
}

// 发送验证码
export const sendCode = (phone: string) => {
  return request.get(`/auth/getPhoneCode/${phone}`) as Promise<ApiResponse<any>>
}

// 获取用户信息
export const getUserInfo = () => {
  return request.get('/auth/getUserInfo') as Promise<ApiResponse<UserInfo>>
}

// 更新用户信息
export const updateUserInfo = (data: Partial<SysUserInfo>) => {
  return request.post('/auth/updateUserInfo', data) as Promise<ApiResponse<any>>
}
